import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      padding: theme.spacingInlineFourpulse,
      minWidth: 260,
      borderRadius: theme.borderRadiusSmallcontainer,
    },
    variants: {
      variants: {
        neutral: {
          backgroundColor: theme.colorFillNeutralAlternative,
        },
        positive: {
          backgroundColor: theme.colorFillSuccessDefault,
        },
        informative: {
          backgroundColor: theme.colorFillInformativeDefault,
        },
        warning: {
          backgroundColor: theme.colorFillWarningDefault,
        },
        negative: {
          backgroundColor: theme.colorFillDangerDefault,
        },
      },
      type: {
        icon: {
          gap: theme.spacingInlineThreepulse,
        },
        highlight: {
          gap: theme.spacingInlineFourpulse,
        },
        text: {},
      },
    },
  }
})
